import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { FormattedHTMLMessage } from 'react-intl'
import FaqCategoryItem from './FaqCategoryItem'
import FaqSuggestion from './FaqSuggestion'

import './FaqItemDetails.scss'

function FaqItemDetails(props) {
  const history = useHistory()
  const dispatch = useDispatch()
  const {
    faqsArticle,
    getRelatedFaq,
    faq: {
      question = '',
      response = '',
      category: { text = '' },
      faqId,
    },
    handleScoring,
    handleFaqDownVoteResponse,
  } = props

  useEffect(() => {
    const controller = new AbortController()
    const { signal } = controller
    let isCalled = false
    history.listen((location, actions) => {
      if (actions === 'POP') {
        const category = location.pathname.split('/')[2]
        const id = location.pathname.split('/')[3]
        if (!category && !id) {
          return
        }
        if (!isCalled) {
          dispatch(() => {
            getRelatedFaq(`${category}/${id}`, { signal })
          })
        }
      }
    })
    return () => {
      isCalled = true
      controller.abort()
    }
  }, [dispatch, getRelatedFaq, history])

  if (!props.faq) return null

  const handleToFaq = faq => {
    const {
      category: { description },
    } = faq
    dispatch(async () => {
      await getRelatedFaq(`${description}/${faq.faqId}`)
    })
    history.push({ pathname: `/faq/${description}/${faq.faqId}` })
  }

  return (
    <div className="FaqItemDetails">
      <div className="FaqItemDetails__topContainer">
        <p>{text}</p>
        <h4>{question}</h4>
      </div>
      <div className="FaqItemDetails__bottomContainer">
        <div className="col">
          <div className="row">
            <FormattedHTMLMessage id={response} />
          </div>
        </div>
        <FaqSuggestion
          handleScoring={handleScoring}
          handleFaqDownVoteResponse={handleFaqDownVoteResponse}
          faqId={faqId}
        />
        {faqsArticle.length > 0 ? (
          <div className="row-sm-6 row-md-8 row-lg-12 related__title">Related Articles</div>
        ) : null}
        <FaqCategoryItem faqs={faqsArticle} handleOnClick={faq => handleToFaq(faq)} />
      </div>
    </div>
  )
}

export default FaqItemDetails
